import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import ModalService from "src/modals"
import { clearHistory, selectHistory, selectLiveGame } from "src/store/game"

import "./HistoryCornerButton.css"

/* The way back to the present while a past round of a live game is on screen (owner, 2026-10-05,
   requirement 35, H6: "Big button in the map appears in a corner like: go to current round").

   It names the live round, and the name follows the clock: the round keeps turning while somebody
   looks back (H5), and the button is where they find out that it did. Escape does what it does,
   once no modal is left to close — the same "undo the mode I am in" the map's Escape keeps. */
const HistoryCornerButton = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useSelector(selectHistory)
  const live = useSelector(selectLiveGame)
  const lookingBack = history != null

  useEffect(() => {
    if (!lookingBack) return undefined
    const onKeyDown = (event) => {
      if (event.key !== "Escape") return
      if (ModalService.closedAModal(event) || ModalService.hasOpenModals()) return
      dispatch(clearHistory())
    }
    window.addEventListener("keydown", onKeyDown)
    return () => window.removeEventListener("keydown", onKeyDown)
  }, [dispatch, lookingBack])

  if (!lookingBack || !live) return null

  return (
    <button
      type="button"
      className="history-corner-button"
      data-action="history-current"
      onClick={() => dispatch(clearHistory())}
      title={t("game.history.goToCurrentTitle")}
    >
      <span className="history-corner-arrow" aria-hidden="true">
        ⏭
      </span>
      {t("game.history.goToCurrent", { round: live.tick })}
    </button>
  )
}

/* "Round T — looking back, no orders": a thin strip across the top of the map, so nobody reads a
   past board as the present one (H6). */
export const HistoryBanner = () => {
  const { t } = useTranslation()
  const history = useSelector(selectHistory)
  if (!history) return null
  return (
    <div className="history-banner" role="status" data-loading={history.loading ? "true" : undefined}>
      {t(history.loading ? "game.history.bannerLoading" : "game.history.banner", { round: history.tick })}
    </div>
  )
}

export default HistoryCornerButton
